<template>
  <div class="row">
    <div class="col">
      <div
        class="border-[1.5px] border-solid border-[#DBDCE0] rounded-[4px] w-full"
      >
        <div class="bg-[#FBFBFB] w-full px-[24px] py-[13px]">
          <p class="text-[#353535] text-[12px] leading-[18px] font-medium">
            List Of System settings
          </p>
        </div>
        <div class="w-full bg-white flex flex-col justify-start">
          <div
            class="max-w-[520px] w-full flex items-center justify-between gap-[48px] cursor-pointer px-[24px] py-[8px] border-b"
          >
            <div class="flex gap-[12px] items-center">
              <img src="/assets/icon/sys.svg" class="w-[40px] h-[40px]" />
              <p
                class="text-[#353535] font-medium leading-[19.36px] text-[16px]"
              >
                Customer receive invoices by SMS
              </p>
            </div>
            <div>
              <button
                @click.prevent="viewEdit(settings)"
                type="button"
                class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer"
                role="switch"
                :aria-checked="isActive"
                :class="{
                  'bg-[#2463eb]': isActive,
                  'bg-[#E4E4E7]': !isActive,
                }"
              >
                <span
                  aria-hidden="true"
                  class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform rounded-full pointer-events-none"
                  :class="{
                    'translate-x-5': isActive,
                    'translate-x-0': !isActive,
                  }"
                ></span>
              </button>
            </div>
          </div>
          <div
            class="max-w-[520px] w-full flex items-center justify-between gap-[48px] cursor-pointer px-[24px] py-[8px]"
          >
            <div class="flex gap-[12px] items-center">
              <img src="/assets/icon/sys.svg" class="w-[40px] h-[40px]" />
              <p
                class="text-[#353535] font-medium leading-[19.36px] text-[16px]"
              >
                Customer receive invoices by Email
              </p>
            </div>
            <div>
              <button
                @click.prevent="viewEdit(settings)"
                type="button"
                class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer"
                role="switch"
                :aria-checked="Active"
                :class="{
                  'bg-[#2463eb]': Active,
                  'bg-[#E4E4E7]': !Active,
                }"
              >
                <span
                  aria-hidden="true"
                  class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform rounded-full pointer-events-none"
                  :class="{
                    'translate-x-5': Active,
                    'translate-x-0': !Active,
                  }"
                ></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="border-[1.5px] border-solid border-[#DBDCE0] rounded-[4px] w-full mt-[48px]"
      >
        <div class="bg-[#FBFBFB] w-full px-[24px] py-[13px]">
          <p class="text-[#353535] text-[12px] leading-[18px] font-medium">
            Others
          </p>
        </div>
        <div class="w-full bg-white flex flex-col justify-start">
          <div
            class="max-w-[600px] w-full flex items-center justify-between gap-[48px] cursor-pointer px-[24px] py-[8px] border-b"
          >
            <div class="flex gap-[12px] items-center">
              <img src="/assets/icon/sys.svg" class="w-[40px] h-[40px]" />
              <p
                class="text-[#353535] font-medium leading-[19.36px] text-[16px]"
              >
                Automatic Order Fulfillment Reconciliation
              </p>
            </div>
            <div>
              <button
                @click.prevent="viewEdit(settings)"
                type="button"
                class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer"
                role="switch"
                :aria-checked="settings.autoOrderFulfillmentReconciliation"
                :class="{
                  'bg-[#2463eb]': settings.autoOrderFulfillmentReconciliation,
                  'bg-[#E4E4E7]': !settings.autoOrderFulfillmentReconciliation,
                }"
              >
                <span
                  aria-hidden="true"
                  class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform rounded-full pointer-events-none"
                  :class="{
                    'translate-x-5':
                      settings.autoOrderFulfillmentReconciliation,
                    'translate-x-0': !settings.autoOrderFulfillmentReconciliation,
                  }"
                ></span>
              </button>
            </div>
          </div>
          <div
            class="max-w-[620px] w-full flex items-center justify-between gap-[48px] cursor-pointer px-[24px] py-[8px] border-b"
          >
            <div class="flex gap-[12px] items-center">
              <img src="/assets/icon/date.svg" class="w-[40px] h-[40px]" />
              <p
                class="text-[#353535] font-medium leading-[19.36px] text-[16px]"
              >
                Set reminder to alert you of expiring product (days)
              </p>
            </div>
            <div
              class="border-[1.5px] border-[#D0D5DD] py-[10px] px-[12px] rounded-[8px]"
            >
              <p
                class="text-[#353535] font-medium leading-[19.36px] text-[16px]"
              >
                {{ settings.defaultProductExpiryNotification }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade overflow-y-scroll" id="mod-edit" role="dialog">
      <div
        class="modal-dialog m-0 p-0 fixed overflow-y-scroll top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#f8f8f8] p-[40px] md:min-h-screen overflow-y-scroll"
        >
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Edit System settings
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="col-12" v-if="errorMessage">
              <div class="alert alert-danger">
                <i class="feather icon-info"></i> {{ errorMessage }}
              </div>
            </div>

            <div class="py-[10px]">
              <div class="flex item-center gap-[10px]">
                <input
                  class="custom-checkbox"
                  type="checkbox"
                  :checked="updateSettings.sendInvoiceAutomatically"
                  v-model="updateSettings.sendInvoiceAutomatically"
                />
                <label
                  class="text-[#353535] font-medium text-[16px] m-0 w-full"
                >
                  Send Invoice Automatically
                </label>
              </div>
            </div>
            <div class="pb-[10px] pl-[20px]">
              <div class="flex item-center gap-[10px]">
                <input
                  class="custom-checkbox"
                  type="checkbox"
                  v-model="updateSettings.sendAutomaticInvoiceViaSms"
                  :checked="updateSettings.sendAutomaticInvoiceViaSms"
                  :disabled="!updateSettings.sendInvoiceAutomatically"
                />
                <label
                  class="text-[#353535] font-medium text-[16px] m-0 w-full"
                >
                  Send Automatic Invoice Via SMS
                </label>
              </div>
            </div>
            <div class="pb-[10px] pl-[20px]">
              <div class="flex item-center gap-[10px]">
                <input
                  class="custom-checkbox"
                  type="checkbox"
                  v-model="updateSettings.sendAutomaticInvoiceViaEmail"
                  :disabled="!updateSettings.sendInvoiceAutomatically"
                  :checked="updateSettings.sendAutomaticInvoiceViaEmail"
                />
                <label
                  class="text-[#353535] font-medium text-[16px] m-0 w-full"
                >
                  Send Automatic Invoice Via Email
                </label>
              </div>
            </div>

            <hr />
            <div class="py-[10px]">
              <div class="pb-[10px]">
                <div class="flex item-center gap-[10px]">
                  <input
                    class="custom-checkbox"
                    type="checkbox"
                    v-model="updateSettings.sendInvoiceManually"
                    :checked="updateSettings.sendInvoiceManually"
                  />
                  <label
                    class="text-[#353535] font-medium text-[16px] m-0 w-full"
                    >Send Invoice Manually
                  </label>
                </div>
              </div>
              <div class="pb-[10px] pl-[20px]">
                <div class="flex item-center gap-[10px]">
                  <input
                    class="custom-checkbox"
                    type="checkbox"
                    v-model="updateSettings.sendManualInvoiceViaSms"
                    :checked="updateSettings.sendManualInvoiceViaSms"
                    :disabled="!updateSettings.sendInvoiceManually"
                  />
                  <label
                    class="text-[#353535] font-medium text-[16px] m-0 w-full"
                    >Send Manual Invoice Via SMS</label
                  >
                </div>
              </div>
              <div class="pb-[10px] pl-[20px]">
                <div class="flex items-center gap-[10px]">
                  <input
                    class="custom-checkbox"
                    type="checkbox"
                    v-model="updateSettings.sendManualInvoiceViaEmail"
                    :checked="updateSettings.sendManualInvoiceViaEmail"
                    :disabled="!updateSettings.sendInvoiceManually"
                  />
                  <label
                    class="text-[#353535] font-medium text-[16px] m-0 w-full"
                    >Send Manual Invoice Via Email
                  </label>
                </div>
              </div>
            </div>

            <hr />
            <div class="py-[10px]">
              <div class="pb-[10px]">
                <label
                  class="text-[#353535] font-medium text-[14px] leading-[20px]"
                  >Default Product Expiry Notification (Days)</label
                >
                <div>
                  <input
                    class="bg-transparent border-[##96a0b5] border-solid border-[1.5px] py-[14px] px-[16px] md:px-[24px] rounded-[8px] text-[14px] md:text-[16px] font-medium leading-[20px] w-full"
                    type="number"
                    v-model="updateSettings.defaultProductExpiryNotification"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="form-group row">
              <label
                class="col-12 col-sm-3 col-form-label text-sm-right"
              ></label>
              <div class="col-12 col-sm-8 col-lg-8">
                <label
                  class="custom-control custom-checkbox custom-control-inline"
                >
                  <input
                    class="custom-checkbox"
                    type="checkbox"
                    v-model="updateSettings.allowGeoFencing"
                  />
                  <span class="custom-control-label">Allow Geo-Fencing</span>
                </label>
              </div>
            </div> -->

            <hr />
            <div class="py-[10px]"></div>
            <div class="pb-[10px]">
              <p
                class="text-[#353535] font-sembold text-[16px] mb-[10px] leading-[20px]"
              >
                Order Fulfillment Reconciliation
              </p>
              <div class="flex item-center gap-[10px]">
                <input
                  type="radio"
                  name="autoOrderReconciliation"
                  value="auto"
                  v-model="orderFulfillmentReconciliationType"
                />
                <label
                  class="text-[#353535] font-medium text-[12px] leading-[20px]"
                >
                  <strong class="text-[14px]">Auto</strong> <br />
                  Select this option if you want fulfilled orders to
                  automatically deplete inventory from the oldest to the newest
                </label>
              </div>
              <br />
              <div class="flex item-center gap-[10px]">
                <input
                  type="radio"
                  name="autoOrderReconciliation"
                  value="manual"
                  v-model="orderFulfillmentReconciliationType"
                />
                <label
                  class="text-[#353535] font-medium text-[12px] leading-[20px]"
                >
                  <strong class="text-[14px]">Manual</strong><br />
                  Select this option if you want to manually reconcile fulfilled
                  orders to inventory
                </label>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              @click="reset"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click.prevent="update"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import moment from "moment";
import { helper } from "@/helper";
import Select2 from "@/components/Select2";
import SystemPermissions from "@/permissions";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "systemSettings",
  components: {
    Select2,
  },
  created() {
    if (!this.hasPermission("System_Settings_View")) {
      this.$router.push("/restricted");
    }
    this.getSystemSettings();
  },
  data() {
    return {
      filter: {
        status: "0",
        qry: "",
        showForMe: false,
      },
      isBusy: false,
      isBusyModal: false,
      updateSettings: {
        sendInvoiceAutomatically: null,
        sendAutomaticInvoiceViaEmail: null,
        sendAutomaticInvoiceViaSms: null,
        sendInvoiceManually: null,
        sendManualInvoiceViaEmail: null,
        sendManualInvoiceViaSms: null,
        defaultProductExpiryNotification: null,
        autoOrderFulfillmentReconciliation: null,
        allowGeoFencing: null,
        id: null,
      },
      orderFulfillmentReconciliationType: "",
      settings: {},
      errorMessage: null,
    };
  },

  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    isActive() {
      return (
        this.settings.sendManualInvoiceViaSms ||
        this.settings.sendAutomaticInvoiceViaSms
      );
    },
    Active() {
      return (
        this.settings.sendAutomaticInvoiceViaEmail ||
        this.settings.sendManualInvoiceViaEmail
      );
    },
  },

  watch: {
    "updateSettings.sendInvoiceAutomatically": function(newVal, oldVal) {
      if (oldVal !== null && newVal === false) {
        this.updateSettings.sendAutomaticInvoiceViaEmail = false;
        this.updateSettings.sendAutomaticInvoiceViaSms = false;
      }
    },
    "updateSettings.sendInvoiceManually": function(newVal, oldVal) {
      if (oldVal !== null && newVal === false) {
        this.updateSettings.sendManualInvoiceViaEmail = false;
        this.updateSettings.sendManualInvoiceViaSms = false;
      }
    },
  },

  methods: {
    reset() {
      this.filter = {
        status: "0",
        qry: "",
        showForMe: false,
      };
    },

    viewExport() {
      //   $("#mod-export").modal("show");
    },

    viewEdit() {
      if (this.settings.autoOrderFulfillmentReconciliation) {
        this.orderFulfillmentReconciliationType = "auto";
      } else {
        this.orderFulfillmentReconciliationType = "manual";
      }
      $("#mod-edit").modal("show");
    },

    viewFilter() {
      $("#mod-filter").modal("show");
    },

    async update() {
      if (
        this.updateSettings.sendInvoiceAutomatically &&
        !this.updateSettings.sendAutomaticInvoiceViaEmail &&
        !this.updateSettings.sendAutomaticInvoiceViaSms
      ) {
        this.errorMessage =
          "Please select at least one means of automatic notification";
      } else if (
        this.updateSettings.sendInvoiceManually &&
        !this.updateSettings.sendManualInvoiceViaEmail &&
        !this.updateSettings.sendManualInvoiceViaSms
      ) {
        this.errorMessage =
          "Please select at least one means of manual notification";
      } else if (!this.updateSettings.defaultProductExpiryNotification) {
        this.errorMessage =
          "Default Product Expiry Notification field is required";
      } else {
        this.errorMessage = null;
        this.isBusyModal = true;
        this.isBusy = true;

        var autoReconciliation = false;
        if (this.orderFulfillmentReconciliationType == "auto") {
          autoReconciliation = true;
        }

        var data = {
          sendInvoiceAutomatically: this.updateSettings
            .sendInvoiceAutomatically,
          sendAutomaticInvoiceViaEmail: this.updateSettings
            .sendAutomaticInvoiceViaEmail,
          sendAutomaticInvoiceViaSms: this.updateSettings
            .sendAutomaticInvoiceViaSms,
          sendInvoiceManually: this.updateSettings.sendInvoiceManually,
          sendManualInvoiceViaEmail: this.updateSettings
            .sendManualInvoiceViaEmail,
          sendManualInvoiceViaSms: this.updateSettings.sendManualInvoiceViaSms,
          defaultProductExpiryNotification: this.updateSettings
            .defaultProductExpiryNotification,
          autoOrderFulfillmentReconciliation: autoReconciliation,
          allowGeoFencing: this.updateSettings.allowGeoFencing,
          id: this.updateSettings.id,
          parentId: this.user.parentId,
        };
        await this.$http
          .put("/SystemSettings/update/" + data.id, data)
          .then(function(res) {
            this.isBusyModal = false;
            $("#mod-edit").modal("hide");
          })
          .catch(function() {
            $("#mod-edit").modal("hide");
          });
        this.reset();
        this.getSystemSettings();
        this.isBusy = false;
        this.isBusyModal = false;
        $("#mod-edit").modal("hide");
      }
    },

    async getSystemSettings() {
      this.isBusy = true;

      await this.$http
        .get("/SystemSettings/getByAccount?parentId=" + this.user.parentId)
        .then(function(res) {
          this.settings = { ...res.body };
          this.updateSettings = { ...res.body };
        })
        .catch(function() {});

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },

    formatDate(date) {
      return moment(date).format("lll");
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },

    reset() {
      this.updateSettings = {
        sendInvoiceAutomatically: null,
        sendAutomaticInvoiceViaEmail: null,
        sendAutomaticInvoiceViaSms: null,
        sendInvoiceManually: null,
        sendManualInvoiceViaEmail: null,
        sendManualInvoiceViaSms: null,
        defaultProductExpiryNotification: null,
        autoOrderFulfillmentReconciliation: null,
        allowGeoFencing: null,
        id: null,
      };
    },
  },
};
</script>
<style scoped>
.custom-checkbox {
  width: 24px;
  height: 18.9px;
  appearance: none;
  border: 1px solid #96a0b5;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  outline: none;
  transition: background-color 0.2s ease-in-out;
}
.custom-checkbox:checked {
  background-color: rgba(36, 99, 235, 0.5);
  border-color: rgba(36, 99, 235, 1);
}

.custom-checkbox:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #2463eb;
  font-size: 14px;
}
input[type="radio"] {
  transform: scale(1.4);
}
</style>
